import { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CopyToClipboard from "react-copy-to-clipboard";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

const Wrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100dvw;
    height: 100dvh;
`
const ImgError = styled.img`
    width: 350px;
`

const TextCont = styled.div`
    margin-left: 80px;
    h1 {
        font-size: 50px;
        font-weight: bold;
    }

    p {
        line-height: 1.4;
        margin-top: 20px;
        font-size: 18px;
    }

    .btn {
        margin-top: 30px;
    }
`;

const CopyIpCont = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f2f2f2;
    font-size: 18px;
    padding: 15px 20px;
    margin-top: 20px;

    svg {
        cursor: pointer;
    }
`;
export default function IpAccessRestriction() {
    const [completeCopy, setCompleteCopy] = useState(false);
    const [tooltipMsg, setTooltipMsg] = useState("클립보드 복사");

    const {state} = useLocation();
    const {ip} = state;
    return (
        <Wrap>
            <ImgError src={process.env.PUBLIC_URL + "/image/img_lost.svg"}/>

            <TextCont>
                <h1>IP 접속 제한</h1>
                <p>
                    해당 IP 주소는 접속이 제한되어 있습니다.
                    <br/>관리자에게 IP 주소 등록을 요청해 주세요.
                </p>
                <CopyIpCont>
                    <p className="mt-0">
                        IP 주소: {ip}
                    </p>
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip style={{ fontSize: "12px", position: "fixed" }}>
                                {tooltipMsg}
                            </Tooltip>
                        }
                    >

                    {
                        completeCopy == -1 ?
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="red" viewBox="0 0 16 16">
                        <path d="M7.005 3.1a1 1 0 1 1 1.99 0l-.388 6.35a.61.61 0 0 1-1.214 0zM7 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0"/>
                        </svg>
                        : 
                        !completeCopy ?
                        <CopyToClipboard text={ip}
                        onCopy={() => {
                            setTooltipMsg("복사완료!");
                            setCompleteCopy(true);
                            
                            setTimeout(() => {
                                setTooltipMsg("클립보드 복사");
                                setCompleteCopy(false);
                            }, 2000);
                        }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#377dff" viewBox="0 0 16 16">
                                <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z"/>
                                <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z"/>
                            </svg>
                        </CopyToClipboard>
                        :
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#377dff" viewBox="0 0 16 16">
                            <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"/>
                        </svg>
                    }
                    </OverlayTrigger>
                </CopyIpCont>
            </TextCont>
        </Wrap>
    )
}